import { useDispatch, useSelector } from 'react-redux'

import { BASE_URL } from '../constants'
import useFetch from '../hooks/useFetch'

import { fetchSuccess, fetchStart, fetchFail } from './actions'

import { getLayerById, getAILayers } from './selectors'

export const useAILayersFetch = () => {
  const dispatch = useDispatch()

  return useFetch(`${BASE_URL}api/AILayers`, {
    onStart: () => dispatch(fetchStart()),
    onSuccess: layers => dispatch(fetchSuccess(layers)),
    onError: error => dispatch(fetchFail(error))
  })
}

export const useAILayer = layerId => {
  const layer = useSelector(getLayerById)(layerId)
  return layer
}

export const useAILayers = () => {
  const layers = useSelector(getAILayers)
  return layers
}
